import { BankAccount } from "../models/bank.account.model";
import { CryptoAccount } from "../models/crypto.account.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getUserBankAccounts = (userId: number): Promise<BankAccount[]> => {
    return new Promise<BankAccount[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/user/bank/${userId}`).then((response) => {
            resolve(response.data as BankAccount[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

export const getUserCryptoAccounts = (userId: number): Promise<CryptoAccount[]> => {
    return new Promise<CryptoAccount[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/user/crypto/${userId}`).then((response) => {
            resolve(response.data as CryptoAccount[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

export const getOrgBankAccounts = (orgId: number): Promise<BankAccount[]> => {
    return new Promise<BankAccount[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/org/bank/${orgId}`).then((response) => {
            resolve(response.data as BankAccount[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

export const getOrgCryptoAccounts = (orgId: number): Promise<CryptoAccount[]> => {
    return new Promise<CryptoAccount[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/org/crypto/${orgId}`).then((response) => {
            resolve(response.data as CryptoAccount[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

// active 

export const getUserActiveBankAccount = (user_id: number): Promise<BankAccount> => {
    return new Promise<BankAccount>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/user/bank/active/${user_id}`).then((response) => {
            resolve(response.data as BankAccount);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

export const getUserActiveCryptoAccount = (user_id: number): Promise<CryptoAccount> => {
    return new Promise<CryptoAccount>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/accounts/user/crypto/active/${user_id}`).then((response) => {
            resolve(response.data as CryptoAccount);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};